import type { TournamentState } from '@ps/web-poker-tile-mappers';
import React from 'react';
import { useSelector } from 'react-redux';

import { TournamentStateFilter } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../../model';

const FilterContainer: React.FC = () => {
  const { widgetDispatch, widgetSelect } = usePokerSundayMillionWidget();
  const filters = useSelector(widgetSelect.getActiveFilters);
  const filteredCount = useSelector(widgetSelect.getTableRowsCount);

  const handleStateFilterClick = (filters: TournamentState[]) => {
    widgetDispatch.setActiveFilters({ state: filters });
  };

  return (
    <TournamentStateFilter
      filters={filters}
      filteredCount={filteredCount}
      handleStateFilterClick={handleStateFilterClick}
    />
  );
};

export default FilterContainer;
